<template>
  <div v-if="links.length > 3" class="flex items-center justify-between">
    <div class="flex flex-wrap -mb-1">
      <template v-for="(link, key) in links">
        <div v-if="link.url === null" :key="key" class="mb-1 mr-1 px-4 py-3 text-gray-400 text-sm leading-4 border " v-html="link.label" />
        <Link v-else :key="`link-${key}`" class="mb-1 mr-1 px-4 py-3 focus:text-blue-500 text-sm leading-4 hover:bg-white border focus:border-blue-500 bg-gray-100" :class="{ 'bg-blue-400 text-white': link.active }" :href="getUrl(link.url)" v-html="link.label" />
      </template>
    </div>
    <div v-if="total">
      Total: {{ total }}
    </div>
  </div>
</template>

<script>
import { Link } from '@inertiajs/vue3'

export default {
  components: {
    Link,
  },
  props: {
    links: Array,
    total: {
      type:Number,
      default: null,
    },
    query: {
      type:String,
      default: null,
    },
  },
  methods: {
    getUrl(url) {
      if (this.query) {
        return `${url}&${this.query}`
      }
      return url
    },
  },
}
</script>
